import { convertObjectToParams, getInfoStaff } from "@/utils";
import {
  GET_BALANCE_EMPLOYEE,
  GET_DEPARTMENT_BY_DIVISION_LIST,
  GET_DIVISION_LIST,
  GET_EMPLOYEE_BY_PROJECT_LIST,
  GET_EMPLOYEE_LIST,
  GET_PROJECT_BY_EMPLOYEE_LIST,
  GET_PROJECT_LIST,
  GET_PROJECT_REDIS_LIST,
  GET_PROJECT_REDIS_LIST_BY_PAGINATION,
  GET_ROLE_LIST,
  GET_RULE_WORK_SCHEDULE_CONFIG_LIST,
  GET_WORK_SCHEDULE_CODE_LIST,
  GET_WORK_SCHEDULE_TYPE_LIST,
  REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE,
  SET_PAGE_SELECT,
} from "../mutation-types";
import http from "./helpers/httpInterceptor";

const state = () => ({
  divisionList: [],
  departmentList: [],
  departmentByDivisionList: [],
  roleList: [],
  employeeList: [],
  employeeByProjectList: [],
  projectRedisList: [],
  projectRedisListByPagination: [],
  pageSelect: 1,
  pageSelectTotal: 0,
  projectList: [],
  projectByEmployeeList: [],
  balanceEmployee: {},
  remainAnnualLeaveByFinancialAndEmployee: null,
  workScheduleCodeList: [],
  workScheduleTypeList: [],
  workRuleWorkScheduleConfigList: [],
});

// mutations
const mutations = {
  [GET_DIVISION_LIST](state, data) {
    state.divisionList = data;
    state.departmentList = getDepartment(data);
    state.departmentList.sort((a, b) => sortName(a, b));
  },
  [GET_DEPARTMENT_BY_DIVISION_LIST](state, data) {
    state.departmentByDivisionList = getDepartment(state.divisionList, data);
    state.departmentByDivisionList.sort((a, b) => sortName(a, b));
  },
  [GET_ROLE_LIST](state, data) {
    state.roleList = data;
  },
  [GET_EMPLOYEE_LIST](state, data) {
    // state.employeeList = formatEmployee(data).slice(0, 150);
    state.employeeList = formatEmployee(data);
  },
  [GET_EMPLOYEE_BY_PROJECT_LIST](state, data) {
    state.employeeByProjectList = formatEmployee(data);
  },
  [GET_PROJECT_LIST](state, data) {
    state.projectList = data;
  },
  [GET_PROJECT_BY_EMPLOYEE_LIST](state, data) {
    state.projectByEmployeeList = data;
  },
  [GET_BALANCE_EMPLOYEE](state, data) {
    state.balanceEmployee = data;
  },
  [REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE](state, data) {
    if (data) {
      const { day, hours } = data;
      state.remainAnnualLeaveByFinancialAndEmployee = { day: day ?? 0, hours: hours ?? 0 };
    } else {
      state.remainAnnualLeaveByFinancialAndEmployee = null;
    }
  },
  [GET_PROJECT_REDIS_LIST](state, data) {
    state.projectRedisList = data;
    state.pageSelect = 1;
    state.pageSelectTotal = Math.ceil(state.projectRedisList.length ?? 0 / 40);
    state.projectRedisListByPagination = state.projectRedisList.slice(0, state.pageSelect * 40);
  },
  [GET_PROJECT_REDIS_LIST_BY_PAGINATION](state, data) {
    const { pageSelect, pageSelectTotal } = state;
    if (pageSelect < pageSelectTotal && !data) {
      state.pageSelect += 1;
      state.projectRedisListByPagination = state.projectRedisList.slice(0, state.pageSelect * 40);
    } else {
      state.pageSelect = data;
      state.projectRedisListByPagination = state.projectRedisList.slice(0, data * 40);
    }
  },
  [SET_PAGE_SELECT](state, data) {
    state.pageSelect = data;
  },
  [GET_WORK_SCHEDULE_CODE_LIST](state, data) {
    state.workScheduleCodeList = data;
  },
  [GET_WORK_SCHEDULE_TYPE_LIST](state, data) {
    state.workScheduleTypeList = data;
  },
  [GET_RULE_WORK_SCHEDULE_CONFIG_LIST](state, data) {
    state.workRuleWorkScheduleConfigList = data;
  },
};

// actions
const actions = {
  getDivisionList({ commit }) {
    return http
      .get(`/tms/filters/get-all-divisions-departments`)
      .then((res) => {
        commit(GET_DIVISION_LIST, res.data.data);
        return res.data;
      })
      .catch((err) => {
        commit(GET_DIVISION_LIST, []);
        throw err;
      });
  },
  getRoleList({ commit }) {
    return http
      .get(`/tms/filters/v2/roles`)
      .then((res) => {
        commit(GET_ROLE_LIST, res.data.data);
        return res.data;
      })
      .catch((err) => {
        commit(GET_ROLE_LIST, []);
        throw err;
      });
  },
  getEmployeeList({ commit }, payload) {
    return http
      .get("/tms/filters/employee?filter=" + payload)
      .then((res) => {
        commit(GET_EMPLOYEE_LIST, res.data.data ?? []);
        return res.data;
      })
      .catch((error) => {
        commit(GET_EMPLOYEE_LIST, []);
        throw error;
      });
  },

  // async getEmployeeListPagination({ commit }, payload) {
  //   let { data, value, page, size } = payload;
  //   if (value || !data || !data.length) {
  //     try {
  //       data = (await http.get("/tms/filters/employee?filter=" + value)).data.data;
  //     } catch (error) {
  //       data = [];
  //       throw error;
  //     }
  //   }

  //   if (data.length) {
  //     let skip = (page - 1) * size;
  //     let takeFrom = skip + 1;
  //     let takeTo = takeFrom + size;
  //     if (skip >= data.length) {
  //       skip = (page - 1) * size + 1;
  //     }
  //     data = data.slice(takeFrom - 1, takeTo - 1);
  //   }

  //   commit(GET_EMPLOYEE_LIST, data ?? []);
  //   return data;
  // },

  getEmployeeListPagination({ commit }, payload) {
    const { value, page, size } = payload;
    return http
      .get("/tms/filters/employee?filter=" + value)
      .then((res) => {
        let result = res.data.data;

        let skip = (page - 1) * size;
        let takeFrom = skip + 1;
        let takeTo = takeFrom + size;
        if (skip >= res.data.data.length) {
          skip = (page - 1) * size + 1;
        }
        result = result.slice(takeFrom - 1, takeTo - 1);
        commit(GET_EMPLOYEE_LIST, result ?? []);
        return result;
      })
      .catch((error) => {
        commit(GET_EMPLOYEE_LIST, []);
        throw error;
      });
  },

  getEmployeeByProjectList({ commit }, payload) {
    return http
      .get(`/tms/filters/get-all-employee-by-project${convertObjectToParams(payload)}`)
      .then((res) => {
        commit(GET_EMPLOYEE_BY_PROJECT_LIST, res.data.data ?? []);
        return res.data;
      })
      .catch((error) => {
        commit(GET_EMPLOYEE_BY_PROJECT_LIST, []);
        throw error;
      });
  },
  getProjectList({ commit }, searchKey) {
    return http
      .get(`tms/filters/get-all-projects?key=${searchKey}`)
      .then((res) => {
        commit(GET_PROJECT_LIST, res.data.data ?? []);
        return res.data;
      })
      .catch((error) => {
        commit(GET_PROJECT_LIST, []);
        throw error;
      });
  },
  getProjectRedisList({ commit }) {
    return http
      .get(`tms/filters/projects`)
      .then((res) => {
        commit(GET_PROJECT_REDIS_LIST, res.data ?? []);
        return res.data;
      })
      .catch((error) => {
        commit(GET_PROJECT_REDIS_LIST, []);
        throw error;
      });
  },
  getProjectByEmployeeList({ commit }, payload) {
    return http
      .get(`tms/filters/employee-projects${convertObjectToParams(payload)}`)
      .then((res) => {
        commit(GET_PROJECT_BY_EMPLOYEE_LIST, res.data.data ?? []);
        return res.data.data;
      })
      .catch((error) => {
        commit(GET_PROJECT_BY_EMPLOYEE_LIST, []);
        throw error;
      });
  },
  getBalanceEmployee({ commit }, payload) {
    return http
      .get(`/tms/filters/get-balance${convertObjectToParams(payload)}`)
      .then((res) => {
        commit(GET_BALANCE_EMPLOYEE, res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        commit(GET_BALANCE_EMPLOYEE, []);
        throw error;
      });
  },
  getRemainAnnualLeaveByFinancialAndEmployee({ commit }, payload) {
    return http
      .get(`/tms/filters/remain-financial-leave${convertObjectToParams(payload)}`)
      .then((res) => {
        commit(REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE, res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        commit(REMAIN_ANNUAL_LEAVE_BY_FINANCIAL_AND_EMPLOYEE, null);
        throw error;
      });
  },
  getWorkScheduleCodeList({ commit }) {
    return http
      .get(`/tms/filters/get-all-work-schedule-codes`)
      .then((res) => {
        commit(GET_WORK_SCHEDULE_CODE_LIST, res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        commit(GET_WORK_SCHEDULE_CODE_LIST, null);
        throw error;
      });
  },
  getWorkScheduleTypeList({ commit }) {
    return http
      .get(`/tms/filters/get-all-work-schedule-types`)
      .then((res) => {
        commit(GET_WORK_SCHEDULE_TYPE_LIST, res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        commit(GET_WORK_SCHEDULE_TYPE_LIST, null);
        throw error;
      });
  },
  getRuleWorkScheduleConfigList({ commit }) {
    return http
      .get(`/tms/filters/get-all-rule-work-schedule-config`)
      .then((res) => {
        commit(GET_RULE_WORK_SCHEDULE_CONFIG_LIST, res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        commit(GET_RULE_WORK_SCHEDULE_CONFIG_LIST, null);
        throw error;
      });
  },
};

const getDepartment = (data, listDivisionIds) => {
  if (!data || data?.length === 0) return [];
  if (!listDivisionIds || listDivisionIds.length === 0) {
    return data.reduce((result, currentDivision) => {
      if (currentDivision.child?.length > 0) {
        result.push(...currentDivision.child);
      }
      return result;
    }, []);
  } else {
    return data.reduce((result, currentDivision, index) => {
      if (listDivisionIds.includes(currentDivision.department_code) && currentDivision.child?.length > 0) {
        result.push(...currentDivision.child, index);
      }
      return result;
    }, []);
  }
};

const formatEmployee = (data) => {
  if (!data || data?.length <= 0) {
    return [];
  }
  return data.map((employee) => {
    const { department_name, user_name, id } = employee;
    return {
      departmentName: department_name?.name ?? "",
      value: user_name,
      key: id,
      label: getInfoStaff(employee),
    };
  });
};

const sortName = (a, b) => {
  if (a.name < b.name) {
    return -1;
  } else if (a.name > b.name) {
    return 1;
  }
  return 0;
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
